import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getCampaignListAPI, getClientAttributes } from '../../../Services';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CheerioButton from '../../../Components/CheerioButton';
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';
import Form from 'react-bootstrap/Form';

const WebhookTriggerModal = ({ data, setData, prevNode, btnDisabled, setBtnDisabled }) => {
  const authtoken = useSelector((state) => state.main.auth_token);

  const [isLoading, setIsLoading] = useState(false);
  const [attributesList, setAttributesList] = useState(['name', 'email', 'mobile']);
  const [variableList, setVariableList] = useState([]);
  const [values, setValues] = useState(data?.values ? data?.values : ['']);
  const [url, setUrl] = useState(data?.url ?? '');
  const [header, setHeader] = useState(
    data?.header ?? {
      key: '',
      value: '',
    }
  );
  const [saveVariables, setSaveVariables] = useState(data?.saveVariables ?? false);
  const [savedAttributes, setSavedAttributes] = useState(data?.savedAttributes ?? [{ attribute: '', value: '' }]);

  useEffect(() => {
    setIsLoading(true);
    setBtnDisabled(true);
    getUserAttributesAPICall();
    if (prevNode?.data?.variable) {
      setVariableList((prev) => {
        return [prevNode?.data?.variable];
      });
    }
  }, []);

  useEffect(() => {
    setData({
      ...data,
      url: url,
      values: values,
      header: header,
      saveVariables: saveVariables,
      savedAttributes: saveVariables ? savedAttributes : []
    });

    if (url === '' || values?.includes('') || values?.includes(null)) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [url, values, header, saveVariables, savedAttributes]);

  const getUserAttributesAPICall = () => {
    let token = authtoken;
    getClientAttributes(token).then((res) => {
      if (res?.flag) {
        setAttributesList((prev) => {
          const arr = res?.data.map((item) => item.attribute);
          return [...prev, ...arr];
        });
      }
    });
  };

  const handleAutocompleteChange = (index, newValue) => {
    setValues((prev) => {
      const newValues = [...prev];
      newValues[index] = newValue;
      return newValues;
    });
  };

  const handleAttributeChange = (index, field, value) => {
    setSavedAttributes(prev => {
      const newAttributes = [...prev];
      newAttributes[index] = {
        ...newAttributes[index],
        [field]: value
      };
      return newAttributes;
    });
  };

  const addAttributeRow = () => {
    if (savedAttributes.length < 20) {
      setSavedAttributes(prev => [...prev, { attribute: '', value: '' }]);
    } else {
      toast.error('Maximum 5 attributes allowed', {});
    }
  };

  const removeAttributeRow = (index) => {
    if (savedAttributes.length > 1) {
      setSavedAttributes(prev => {
        const newAttributes = [...prev];
        newAttributes.splice(index, 1);
        return newAttributes;
      });
    } else {
      toast.error('At least one attribute is required', {});
    }
  };

  return (
    <>
      <div className="w-100 h-100 py-3 d-flex flex-column justify-content-start align-items-start">
        <div className="form-group" style={{ width: '100%', marginBlockEnd: '15px' }}>
          <label
            htmlFor="exampleFormControlInput1"
            style={{ fontWeight: '700', fontSize: '14px', color: 'black', marginBlockEnd: '5px' }}
          >
            URL
          </label>

          <input
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="form-control shadow-none"
            placeholder="Enter url"
          />
        </div>
        <div className="form-group" style={{ width: '100%', marginBlockEnd: '15px' }}>
          <label
            htmlFor="exampleFormControlInput1"
            style={{ fontWeight: '700', fontSize: '14px', color: 'black', marginBlockEnd: '5px' }}
          >
            Header
          </label>
          <div className="d-flex justify-content-between">
            <input
              value={header?.key}
              onChange={(e) =>
                setHeader((prev) => {
                  return { ...prev, key: e.target.value };
                })
              }
              className="form-control shadow-none"
              placeholder="Enter Key"
              style={{ width: '45%' }}
            />
            <input
              value={header?.value}
              onChange={(e) =>
                setHeader((prev) => {
                  return { ...prev, value: e.target.value };
                })
              }
              className="form-control shadow-none"
              placeholder="Enter Value"
              style={{ width: '45%' }}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#ECE1FF',
            marginBlockEnd: '5px',
            borderRadius: '8px',
            alignItems: 'center',
            paddingBlock: '10px',
            paddingInline: '15px',
          }}
        >
          <p
            style={{
              fontWeight: 400,
              fontSize: 14,
              width: '85%',
              color: '#8E53F7',
            }}
          >
            NOTE:-If you dont see your variable name in list just type your variable name with "@".
          </p>
        </div>
        <h4 className="" style={{ marginBottom: '5px', fontWeight: '600' }}>
          {'Choose attributes/variables'}
        </h4>
        {values.map((val, index) => {
          return (
            <div key={`value-${index}`} className="w-100 my-2">
              <p style={{ fontWeight: '600' }}>Input {index + 1}</p>

              <div className="d-flex w-100 align-items-center">
                <Autocomplete
                  disablePortal
                  id={`combo-box-demo-${index}`}
                  style={{
                    width: '100%',
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      name="variable"
                      size={'small'}
                      placeholder={'Type/Select'}
                      className={'restylingLabels'}
                      InputProps={{
                        notched: false,
                        style: {
                          borderRadius: 4,
                        },
                      }}
                      {...params}
                    />
                  )}
                  value={val}
                  onInputChange={(e, newValue) => handleAutocompleteChange(index, newValue)}
                  onChange={(e, newValue) => handleAutocompleteChange(index, newValue)}
                  options={[...variableList, ...attributesList].map((val) => `${val}`)}
                />
                <img
                  src={images.DeleteBlack}
                  style={{
                    height: 24,
                    width: 20,
                    objectFit: 'contain',
                    marginInlineStart: 8,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (index == 0) {
                      toast.error(
                        'Cannot delete first condition, atleast one condition is mandatory',
                        {}
                      );
                    } else {
                      setValues((prev) => {
                        let temp = [...prev];
                        temp.splice(index, 1);
                        return temp;
                      });
                    }
                  }}
                  alt="Delete"
                />
              </div>
            </div>
          );
        })}
        <div className="d-flex justify-content-center w-100">
          <CheerioButton
            borderStyle={{ marginBlockStart: 16, width: '100%' }}
            textStyle={{
              color: colors.black,
              fontWeight: '600',
            }}
            btnText={'Add More'}
            icon={images.IconAdd}
            backColor={colors.white}
            onclick={() => {
              setValues((prev) => {
                let temp = [...prev];
                temp.push('');
                return temp;
              });
            }}
          />
        </div>
      </div>

      <div className="d-flex flex-row justify-content-between align-items-center w-100 mb-4 mt-2">
        <Form.Check
          type="checkbox"
          className="btncustom"
          style={{ outline: 'none', boxShadow: 'none' }}
          checked={saveVariables}
          label="Save response in variable"
          onChange={() => {
            setSaveVariables(!saveVariables);
          }}
        />
      </div>

      {saveVariables && (
        <div className="w-100">
          <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>
            Save Response Variables
          </h4>

          {savedAttributes.map((item, index) => (
            <div key={`attr-${index}`} className="d-flex w-100 mb-3 align-items-center">
              <div style={{ width: '45%', marginRight: '10px' }}>
                <label style={{ fontWeight: '500', fontSize: '14px', marginBottom: '5px' }}>
                  Choose attribute
                </label>
                <Autocomplete
                  disablePortal
                  id={`attribute-${index}`}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      size={'small'}
                      placeholder={'Type/Select an attribute'}
                      className={'restylingLabels'}
                      InputProps={{
                        notched: false,
                        style: {
                          borderRadius: 4,
                        },
                      }}
                      {...params}
                    />
                  )}
                  value={item.attribute}
                  onInputChange={(e, newValue) => handleAttributeChange(index, 'attribute', newValue)}
                  onChange={(e, newValue) => handleAttributeChange(index, 'attribute', newValue)}
                  options={attributesList}
                  getOptionLabel={(option) => option || ''}
                />
              </div>

              <div style={{ width: '45%' }}>
                <label style={{ fontWeight: '500', fontSize: '14px', marginBottom: '5px' }}>
                  Enter Value
                </label>
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Type/Select"
                  value={item.value}
                  onChange={(e) => handleAttributeChange(index, 'value', e.target.value)}
                  InputProps={{
                    notched: false,
                    style: {
                      borderRadius: 4,
                    },
                  }}
                />
              </div>

              <img
                src={images.DeleteBlack}
                style={{
                  height: 24,
                  width: 20,
                  objectFit: 'contain',
                  marginLeft: '10px',
                  marginTop: '20px',
                  cursor: 'pointer',
                }}
                onClick={() => removeAttributeRow(index)}
                alt="Delete"
              />
            </div>
          ))}

          {savedAttributes.length < 20 && (
            <div className="d-flex justify-content-center w-100">
              <CheerioButton
                borderStyle={{ marginBlockStart: 16, width: '100%' }}
                textStyle={{
                  color: colors.black,
                  fontWeight: '600',
                }}
                btnText={'Add Attribute'}
                icon={images.IconAdd}
                backColor={colors.white}
                onclick={addAttributeRow}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default WebhookTriggerModal;